import { StyledComponentProps } from "@mui/styles";
import * as api from "api/Knowledge";
import { FeedClassKey } from "assets/jss/common-styles";
import ButtonFollow from "components/Buttons/ButtonFollow";
import ButtonGetAnswer from "components/Buttons/ButtonGetAnswer";
import ButtonRepassQuestion from "components/Buttons/ButtonRepassQuestion";
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import { FeedItemDto } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import QuestionRepassDrawer from "views/Timeline/Dialogs/QuestionRepassDrawer";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    menuAnchorEl: HTMLElement;
    dialog: any;
    followUpdating: boolean;
}

interface IProps {
    data: FeedItemDto;
    fullView: boolean;
    onRequestNewPublication?: () => void;
    onUpdateCard: (data: DeepPartial<FeedItemDto>) => void;
}

type Props = IProps & StyledComponentProps<FeedClassKey> & WithSnackbar & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class ActionsQuestion extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            menuAnchorEl: null,
            dialog: null,
            followUpdating: false
        };
    }

    ///
    private handleCloseDialog(): void {
        this.setState({ dialog: null });
    }

    ///
    private handleQuestionRepass(publicationId: string) {
        const { t } = this.props;
        this.setState({
            dialog: <QuestionRepassDrawer
                publicationId={publicationId}
                onClose={
                    (result) => {
                        this.handleCloseDialog();
                        if (result) {
                            api.requestQuestionAnswer(publicationId, result.member, result.comment)
                                .finally(() => {
                                    this.props.snackbar.showMessage(t("Common.Feed.Messages.QuestionRepassed"), "success");
                                });
                        }
                    }
                }
            />
        });
    }

    ///
    private handleQuestionFollow(publicationId: string) {
        const { t } = this.props;
        const following = this.props.data.interaction.following;

        this.setState({ followUpdating: true });

        const callApi = !following
            ? api.followPublication
            : api.unfollowPublication;

        callApi(publicationId)
            .then((result) => {
                if (result) {
                    //if (following)
                    //    this.props.snackbar.showMessage(t("Common.Feed.Messages.UnfollowingQuestionSuccess"), "warning");
                    //else
                    //    this.props.snackbar.showMessage(t("Common.Feed.Messages.FollowingQuestionSuccess"), "success");
                    this.props.onUpdateCard({ publicationId, interaction: { following: !following } });
                }
            })
            .finally(() => {
                this.setState({ followUpdating: false });
            });
    }

    ///
    public render() {

        const {
            data: {
                publicationId,
                interaction: {
                    following
                }
            }
        } = this.props;

        return (
            <>
                {
                    this.props.onRequestNewPublication &&
                    <ButtonGetAnswer
                        color={this.props.fullView ? "success" : "transparent"}
                        onClick={() => { this.props.onRequestNewPublication(); }}
                    />
                }

                <ButtonRepassQuestion
                    onClick={() => { this.handleQuestionRepass(publicationId); }}
                />

                <ButtonFollow
                    following={following}
                    onClick={() => { this.handleQuestionFollow(publicationId); }}
                    updating={this.state.followUpdating}
                />

                {this.state.dialog}
            </>
        );
    }
}

export default withSnackbar(withTranslation()(ActionsQuestion));
